import {Component, Inject} from '@angular/core';
import {MatButtonModule} from '@angular/material/button';
import {MAT_DIALOG_DATA, MatDialogModule, MatDialogRef,} from '@angular/material/dialog';
import {CommonModule} from '@angular/common';

@Component({
  selector: 'app-show-dialogs',
  standalone: true,
  imports: [CommonModule, MatDialogModule, MatButtonModule],
  template: `
    <div class="dlg-h">
      <span class="ico" [class.ico-error]="data.danger" [class.ico-neutral]="!data.danger" aria-hidden="true">
        <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor"
             stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M10.3 3.9 1.8 18a2 2 0 0 0 1.7 3h17a2 2 0 0 0 1.7-3L13.7 3.9a2 2 0 0 0-3.4 0Z"/>
          <path d="M12 9v4"/><path d="M12 17h.01"/>
        </svg>
      </span>
      <div class="dlg-htext">
        <div class="dlg-title">{{ data.title }}</div>
      </div>
    </div>

    <mat-dialog-content class="mat-typography dlg-b">
      <p class="dlg-msg">{{ data.message }}</p>
    </mat-dialog-content>

    <mat-dialog-actions align="end" class="dlg-f">
      <button mat-button class="btn-ghost" [mat-dialog-close]="false">
        {{ data.cancelText || 'Cancel' }}
      </button>
      <button mat-button class="btn-primary" [mat-dialog-close]="true" cdkFocusInitial>
        {{ data.confirmText || 'Confirm' }}
      </button>
    </mat-dialog-actions>
  `,
  styles: [`
    :host{
      --brand:#E60000;--brand-d:#B80000;--ink:#1A1A1A;--muted:#6B7280;--line:#E5E7EB;--bad:#DC2626;
    }
    .dlg-h{display:flex;gap:14px;align-items:center;padding:20px 22px 12px;
      font-family:'Inter',system-ui,-apple-system,'Segoe UI',Roboto,Arial,sans-serif;color:var(--ink);
      min-width:340px;max-width:460px}
    .ico{width:38px;height:38px;border-radius:10px;display:flex;align-items:center;justify-content:center;flex-shrink:0}
    .ico-error{background:#FDECEC;color:var(--bad)}
    .ico-neutral{background:#F1F3F5;color:var(--muted)}
    .dlg-title{font-size:17px;font-weight:700;line-height:1.3;
      font-family:'Inter',system-ui,-apple-system,'Segoe UI',Roboto,Arial,sans-serif}
    .dlg-b{padding:4px 22px 18px !important;margin:0}
    .dlg-msg{font-size:14px;color:#374151;line-height:1.55;margin:0;
      font-family:'Inter',system-ui,-apple-system,'Segoe UI',Roboto,Arial,sans-serif}
    .dlg-f{display:flex;justify-content:flex-end;gap:10px;padding:14px 22px !important;
      border-top:1px solid var(--line);background:#FCFCFD;margin:0;min-height:auto}
    .btn-ghost{background:#fff;color:#374151;border:1px solid var(--line);border-radius:9px;
      padding:0 18px;height:38px;font-size:14px;font-weight:600}
    .btn-ghost:hover{background:#F9FAFB}
    .btn-primary{background:var(--brand);color:#fff;border:none;border-radius:9px;
      padding:0 18px;height:38px;font-size:14px;font-weight:600}
    .btn-primary:hover{background:var(--brand-d)}
  `],
})
export class ShowDialogsComponent {
  constructor(
    public dialogRef: MatDialogRef<ShowDialogsComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
  }
}
